import React from 'react';
import { Dropdown, DropdownItemProps, Form } from 'semantic-ui-react';

export type DropdownWithSearchProps = {
  label?: string;
  className?: string;
  style?: React.CSSProperties;
  error?: boolean;
  placeholder?: string;
  loading?: boolean;
  value: string | undefined;
  disabled?: boolean;
  options: DropdownItemProps[];
  onChange: (_: any, data: { value?: any }) => void;
};

function DropdownWithSearch({
  value,
  options,
  onChange,
  label,
  placeholder,
  error,
  loading,
  className,
  style,
  disabled,
}: DropdownWithSearchProps) {
  return (
    <Form.Field style={style} required className={className}>
      {label && <label>{label}</label>}
      <Dropdown
        className={`${className}__dropdown`}
        error={error}
        placeholder={placeholder}
        loading={loading}
        search
        selection
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Form.Field>
  );
}

export default DropdownWithSearch;
